import { AFAuthorization, AFEntity, AFPersonalInformation, Attachment } from '../model/af.model';

abstract class Event {
}

abstract class EventWithPayload<T> extends Event {
    public readonly payload: T;

    constructor(payload: T) {
        super();
        this.payload = payload;
    }
}

export interface EventIdPayload { id: number }
export interface EventTextPayload { httpStatus: number, text: string }
export interface EventLoginPayload { afEntity: AFEntity }
export interface EventBooleanPayload { show: boolean }
export interface EventCpaPayload { show: boolean, cpaStates: string[] }
export interface EventPiPayload { piData: AFPersonalInformation }
export interface EventFcraPayload { authData: AFAuthorization }
export interface EventWithoutPayload { }
export interface EventNavigationPayload { id: number }
export interface EventValidateAndNavigatePayload { id: number, nextNavLink: string, currentLink: string, save: boolean, saveAndFinishLater: boolean }
export interface EventAttachmentPayload { file: any, inProgress: boolean }
export interface EventDataPayload { text: string }
export interface EventExpireProgressBarPayload { progress: number, minutesLeft: number }

export class ChangeNavigationEvent extends EventWithPayload<EventNavigationPayload> { }
export class ProgressBarEvent extends EventWithPayload<EventIdPayload> { }

export class ChangeLoginEvent extends EventWithPayload<EventLoginPayload> { }
export class ShowProgressEvent extends EventWithPayload<EventBooleanPayload> { }
export class UserDataEvent extends EventWithPayload<EventLoginPayload> { }
export class PIEvent extends EventWithPayload<EventPiPayload> { }
export class OtherNameEvent extends EventWithPayload<EventPiPayload> { }
export class ValidateAndNavigateEvent extends EventWithPayload<EventValidateAndNavigatePayload> { }
export class ShowErrorEvent extends EventWithPayload<EventTextPayload> { }
export class ShowLoaderEvent extends EventWithPayload<EventBooleanPayload> { }
export class BeforeSubmitErrorEvent extends EventWithPayload<EventWithoutPayload> { }
export class UploadEvent extends EventWithPayload<EventWithoutPayload> { }
export class ValidateAndSubmitEvent extends EventWithPayload<EventWithoutPayload> { }
export class AttachmentUploadedEvent extends EventWithPayload<EventAttachmentPayload> { }
export class ClientErrorEvent extends EventWithPayload<EventDataPayload> { }
export class ShowSuccesDialogEvent extends EventWithPayload<EventDataPayload> { }
export class SessionExpireEvent extends EventWithPayload<EventDataPayload> { }
export class SessionExpireProgressBarEvent extends EventWithPayload<EventExpireProgressBarPayload> { }
export class FormSubmittedEvent extends EventWithPayload<EventDataPayload> { }
export class SubmitApplicantEvent extends EventWithPayload<EventWithoutPayload> { }
export class ConsumerPrivacyActEvent extends EventWithPayload<EventCpaPayload> { }
export class SkipToMainContentEvent extends EventWithPayload<EventDataPayload> { }  
export class DismissSnackBarEvent extends EventWithPayload<EventWithoutPayload> { }
export class SkipToTopContentEvent extends EventWithPayload<EventWithoutPayload> { }  
export class CountryMistmatchEvent extends EventWithPayload<EventBooleanPayload> { } 
export class EmploymentGapEvent extends EventWithPayload<EventBooleanPayload> { }   

export type EventTypes = ChangeNavigationEvent;
